export const setLastEntries = (lastEntries, timeSinceLastReading, systemId) => {
  return {
    type: 'SET_LAST_ENTRIES',
    payload: {
      lastEntries,
      timeSinceLastReading,
      systemId
    }
  };
};

export const setLastEntriesLoading = (systemId) => {
  return {
    type: 'SET_LAST_ENTRIES_LOADING',
    payload: {
      systemId
    }
  };
};

export const setLastEntriesError = (systemId) => {
  return {
    type: 'SET_LAST_ENTRIES_ERROR',
    payload: {
      systemId
    }
  };
};

export const setSensorMetrics = (metrics, sensorId, timePreset) => {
  return {
    type: 'SET_SENSOR_METRICS',
    payload: {
      metrics,
      sensorId,
      timePreset
    }
  };
};

export const setSensorMetricsLoading = (sensorId, timePreset) => {
  return {
    type: 'SET_SENSOR_METRICS_LOADING',
    payload: {
      sensorId,
      timePreset
    }
  };
};

export const setSensorMetricsError = (sensorId, timePreset) => {
  return {
    type: 'SET_SENSOR_METRICS_ERROR',
    payload: {
      sensorId,
      timePreset
    }
  };
};
